import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteTokens } from '../../utils/auth';
import http from '../../utils/api/http';

export const signIn = createAsyncThunk('auth/signIn', async (data) => {
    const response = await http.post('api/v1/social-login', data);
    return response;
});

export const getProviderUrl = createAsyncThunk(
    'auth/provider',
    async (data) => {
        const response = await http.post('api/v1/provider/redirect', data);
        return response;
    },
);

export const signOut = createAsyncThunk('auth/signOut', async () => {
    await http.post('api/v1/logout');
    deleteTokens();
});

export const getAuthenticatedUser = createAsyncThunk(
    'auth/authenticated',
    async () => {
        const { data } = await http.get('api/v1/user');
        return data.data;
    },
);

const initialState = {
    userEmail: '',
    loginStatus: 'idle',
    errors: {},
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: {
        [signIn.pending]: (state, action) => {
            state.loginStatus = 'loading';
        },
        [signIn.fulfilled]: (state, action) => {
            state.loginStatus = 'succeeded';
        },
        [signIn.rejected]: (state, action) => {
            state.loginStatus = 'failed';
        },
        [getProviderUrl.pending]: (state, action) => {
            state.loginStatus = 'loading';
        },
        [getProviderUrl.fulfilled]: (state, action) => {
            state.loginStatus = 'succeeded';
        },
        [getProviderUrl.rejected]: (state, action) => {
            state.loginStatus = 'failed';
        },
        [getAuthenticatedUser.pending]: (state, action) => {
            state.loginStatus = 'loading';
        },
        [getAuthenticatedUser.fulfilled]: (state, action) => {
            state.loginStatus = 'succeeded';
            state.userEmail = action.payload.email;
        },
        [getAuthenticatedUser.rejected]: (state, action) => {
            state.loginStatus = 'failed';
        },
    },
});

/* Selectors */
export const getAppLoginStatus = (state) => state.auth.loginStatus;
export const userEmail = (state) => state.auth.userEmail;

export default authSlice.reducer;
